import { h } from "preact";
import { Card } from 'antd';
import SettingItem from './SettingItem';

const SettingsGroup = ({
                           group,
                           settings,
                           globalSettings = {},
                           loading,
                           onToggle,
                           onSettingChange
                       }) => {
    const isDisabledByMaster = group.dependsOn && settings[group.dependsOn] === true;

    const isGloballyDisabled = (setting) => globalSettings[setting.key] === !!setting.invertLogic;

    return (
        <Card
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{group.icon}</span>
                    <span>{group.title}</span>
                    {isDisabledByMaster && (
                        <span style={{
                            fontSize: '12px',
                            color: '#ff4d4f',
                            fontWeight: 'normal',
                            marginLeft: '8px'
                        }}>
                            (Disabled by FPE Master Switch)
                        </span>
                    )}
                </div>
            }
            style={{
                marginBottom: '24px',
                opacity: isDisabledByMaster ? 0.6 : 1,
                transition: 'opacity 0.3s ease'
            }}
        >
            {group.settings.map(setting => {
                const globallyDisabled = isGloballyDisabled(setting);
                return (
                    <SettingItem
                        key={setting.key}
                        title={setting.title}
                        description={setting.description}
                        settingKey={setting.key}
                        apiMethods={setting.apiMethods}
                        settings={settings}
                        loading={loading}
                        onToggle={onToggle}
                        disabled={isDisabledByMaster || globallyDisabled}
                        globallyDisabled={globallyDisabled}
                        isMaster={setting.isMaster}
                        invertLogic={setting.invertLogic}
                    />
                );
            })}
        </Card>
    );
};

export default SettingsGroup;